/* eslint-disable import-x/no-default-export */
import Chance from 'chance';
const chance = new Chance();

export default () =>
  chance.pickset(
    [
      {
        id: chance.guid(),
        name: {
          text: 'English',
          ontologyId:
            'https://graph.cloud.seek.com/Spec-Req/4589e2d7-b21e-493e-8f4b-53c912b53b11',
        },
      },
      {
        id: chance.guid(),
        name: {
          text: 'Spanish',
          ontologyId:
            'https://graph.cloud.seek.com/Spec-Req/6235f9ee-d424-4f19-a250-2ae890d82027',
        },
      },
      {
        id: chance.guid(),
        name: {
          text: 'French',
          ontologyId:
            'https://graph.cloud.seek.com/Spec-Req/f3daa861-e94e-477c-a4ab-abc97c6bc69c',
        },
      },
    ],
    chance.integer({ min: 0, max: 3 }),
  );
